import { render, staticRenderFns } from "./Producer.vue?vue&type=template&id=a7d253e0&scoped=true&"
import script from "./Producer.vue?vue&type=script&lang=js&"
export * from "./Producer.vue?vue&type=script&lang=js&"
import style0 from "./Producer.vue?vue&type=style&index=0&id=a7d253e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d253e0",
  null
  
)

export default component.exports